/**
 * Rich HTML popover content for symbol bar tooltips.
 * Migrated from the legacy AngularJS PopoverTexts.js resource.
 * Image paths updated from Content/images/ to /assets/images/.
 */

const IMG_BASE = '/assets/images';

interface PopoverTextMap {
    [key: string]: string | PopoverTextMap;
}

const PopoverTexts: PopoverTextMap = {
    status: {
        approvedtrue: 'The values and procedures of this product have been quality checked and approved',
        approvedfalse: 'The values and procedures of this product have <strong>NOT</strong> been quality checked and/or approved',
    },

    generalInformation: {
        regulation1: `Annex I <br/><img src="${IMG_BASE}/AnnexI.png" style="width:80px; height:80px;" alt="Annex I"/>`,
        regulation2: `Annex II - Chapter 17 <br/><img src="${IMG_BASE}/AnnexII.png" style="width:80px; height:80px;" alt="Annex II"/>`,
        regulation3: `Annex II - Chapter 18 <br/><img src="${IMG_BASE}/AnnexII.png" style="width:80px; height:80px;" alt="Annex II Ch.18"/>`,
        regulation4: `IGC <br/><img src="${IMG_BASE}/Gas.png" style="width:80px; height:80px;" alt="IGC"/>`,
        hazards1: `Explosives <br/><img src="${IMG_BASE}/HazardClass1.gif" style="width:80px; height:80px;" alt="IMDG Class 1"/>`,
        hazards2: `Gases: Compressed, Liquefied or Dissolved under Pressure <br/><img src="${IMG_BASE}/HazardClass2.gif" style="width:80px; height:80px;" alt="IMDG Class 2"/>`,
        hazards3: `Flammable Liquids <br/><img src="${IMG_BASE}/HazardClass3.gif" style="width:80px; height:80px;" alt="IMDG Class 3"/>`,
        hazards4: `Flammable Solids or Substances <br/><img src="${IMG_BASE}/HazardClass4.gif" style="width:80px; height:80px;" alt="IMDG Class 4"/>`,
        hazards5: `Oxidizing Substances (agents) and Organic Peroxides <br/><img src="${IMG_BASE}/HazardClass52.gif" style="width:80px; height:80px;" alt="IMDG Class 5"/>`,
        hazards6: `Toxic And Infectious Substances <br/><img src="${IMG_BASE}/HazardClass6.gif" style="width:80px; height:80px;" alt="IMDG Class 6"/>`,
        hazards7: `Radioactive Substances <br/><img src="${IMG_BASE}/HazardClass7.gif" style="width:80px; height:80px;" alt="IMDG Class 7"/>`,
        hazards8: `Corrosives <br/><img src="${IMG_BASE}/HazardClass8.gif" style="width:80px; height:80px;" alt="IMDG Class 8"/>`,
        hazards9: `Miscellaneous Dangerous Substances And Articles <br/><img src="${IMG_BASE}/HazardClass9.gif" style="width:80px; height:80px;" alt="IMDG Class 9"/>`,
    },

    rulesAndRegulations: {
        pollutionCategory1: 'X - Present a major hazard to marine environment or human health',
        pollutionCategory2: 'Y - Present a hazard to marine environment or human health',
        pollutionCategory3: 'Z - Present a minor hazard to marine environment or human health',
        pollutionCategory4: 'OS - Present no harm to marine environment or human health',
        shipType1: '1 - For products with very severe environmental and safety hazards.<br/>Double Side: Min B/5. Double Bottom: B/15. Max 1250 M3',
        shipType2: '2 - For products with appreciable severe environmental and safety hazards.<br/>Double skin/double bottom tanks with minimum distance of 760mm from ships side. Max cargo allowed 3000m3 per tank.',
        shipType3: '2k - For products with appreciable severe environmental and safety hazards.<br/>Double skin/double bottom tanks with minimum distance of 760mm from ships side.',
        shipType4: '3 - For products with sufficiently severe environmental and safety hazards.<br/>Single skin cargo tanks',
    },

    cleaningProcedures: {
        cleaningDifficulty1: `Easy <br/><img src="${IMG_BASE}/Cleaning1.png" style="width:80px; height:80px;" alt="Easy"/>`,
        cleaningDifficulty2: `Medium <br/><img src="${IMG_BASE}/Cleaning2.png" style="width:80px; height:80px;" alt="Medium"/>`,
        cleaningDifficulty3: `Hard <br/><img src="${IMG_BASE}/Cleaning3.png" style="width:80px; height:80px;" alt="Hard"/>`,
    },

    warnings: {
        lowFlashPointWarningSOLAS: 'This is a low flash point product. Check SOLAS for inert gas requirements.',
        lowFlashPointWarningIBC:
            "The flash point of this product is very low. According to IBC 8.3.6 these products should only be transported in tanks fitted with 'controlled tank venting systems'. Check cargo handling procedures — special electrical systems and a flammable-vapour detector may be required.",
        ibc16_2_6Warning: 'The IBC Specific Requirement 16.2.6 applies to this product.',
        ibc16_2_7Warning: 'The IBC Specific Requirement 16.2.7 applies to this product.',
        ibc16_2_9Warning: 'The IBC Specific Requirement 16.2.9 applies to this product.',
        ibc15_13Warning: 'The IBC Specific Requirement 15.13 applies to this product.',
        staticAccumulatorWarning:
            'The product has an electrical conductivity of less than 50 picoSiemens/meter (pS/m), capable of retaining a significant electrostatic charge.',
        cleaningFlashPointWarning:
            "Cleaning procedure for cargoes with flash point between 60°C and 110°C. If cleaning water is less than 10°C below flashpoint, owners procedures for cleaning of flammable products to be followed.",
    },
};

/**
 * Resolves a dot-delimited path (e.g. "generalInformation.regulation2") to its HTML content.
 * Returns undefined when the path does not exist.
 */
export function resolvePopoverText(path: string): string | undefined {
    const parts = path.split('.');
    let current: string | PopoverTextMap | undefined = PopoverTexts;

    for (const part of parts) {
        if (typeof current !== 'object' || current === null) return undefined;
        current = (current as PopoverTextMap)[part];
    }

    return typeof current === 'string' ? current : undefined;
}

export default PopoverTexts;
